
// Captalize the first letter of each word in a string
export const capitalizeWords = (str) => {
    if (!str) return '';
    return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, m => m.toUpperCase());
};

export const convertToArabicNumbers = (phoneNumber) => {
    const arabicNumerals = {
        '0': '٠',
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩'
    };

    return phoneNumber.split('').map(char => arabicNumerals[char] || char).join('');
}

export const formatPrice = (amount, lang = "en", currency = "$") => {
    if (!amount) {
        return `$0.00`;
    }

    let validAmount = parseFloat(amount);

    if (isNaN(validAmount)) {
        validAmount = 0;
    }

    let formattedAmount = validAmount
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (lang === "ar") {
        return `${convertToArabicNumbers(formattedAmount)}$`;
    }

    return `$${formattedAmount}`;
};

export const paymentMethods = [
    { label: 'Cash App', value: 'Cash App' },
    { label: 'Zelle', value: 'Zelle' },
    // { label: 'Bank Transfer', value: 'Bank Transfer' },
    { label: 'PayPal', value: 'PayPal' },
    { label: 'Venmo', value: 'Venmo' },
];